
<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="my-3 mx-2">
            <div class="d-flex align-items-center my-1">
                <div class="mx-2 h3">Posts</div>
                <router-link to="/posts/add">
                    <button class="btn btn-sm border border-primary text-primary" v-if="permissions.ADD_CONTENT == 'Y'">
                        Add New Post
                    </button>
                </router-link>
            </div>
            <AllElements category_id="1" editLink="posts"></AllElements>
        </div>
    </div>
</template>
<script>
import AllElements from "@/components/ElementComponents/AllElements";

export default {
    created() {
        this.permissions = JSON.parse(localStorage.getItem("permissions"));
    },
    data() {
        return {
            permissions: {},
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Posts',
                    to: '/posts/all'
                }, {
                    text: 'All Posts',
                    href: '#'
                }
            ],
        }
    },
    setup() { },
    components: {
        AllElements,
    },
};
</script>